module.exports = __webpack_public_path__ + "img/fcca.969223d7.svg";